import { createSlice } from "@reduxjs/toolkit";
import { edit_profile_thunk, get_user_thunk, login_thunk, register_thunk, update_user_thunk, verify_code_thunk } from "./authThunk";

const initialState = {
  loading: false,
  user: null,
  error: null,
  isLogin: false,
};

const loginCases = (builder) => {
  builder
    // Add cases for regular login
    .addCase(login_thunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(login_thunk.fulfilled, (state, action) => {
      // state.isLogin = true;
      state.loading = false;
    })
    .addCase(login_thunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || "Login Failed";
    });
};

const registerCases = (builder) => {
  builder
    .addCase(register_thunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(register_thunk.fulfilled, (state, action) => {
      state.loading = false;
    })
    .addCase(register_thunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || "Registration Failed";
    });
};

const verifyCodeCases = (builder) => {
  builder
    .addCase(verify_code_thunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(verify_code_thunk.fulfilled, (state, action) => {
      // state.isLogin = true;
      state.loading = false;
    })
    .addCase(verify_code_thunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || "Verification Failed";
    });
};

const getUserCases = (builder) => {
  builder
    .addCase(get_user_thunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(get_user_thunk.fulfilled, (state, action) => {
      state.user = action.payload.data.response;
      state.loading = false;
    })
    .addCase(get_user_thunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || "Get User Cases Error";
    });
};

const updateUserCases = (builder) => {
  builder
    .addCase(update_user_thunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(update_user_thunk.fulfilled, (state, action) => {
      state.user = action.payload.data.response;
      state.loading = false;
    })
    .addCase(update_user_thunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || "Update User Cases Error";
    });
};

const editProfileCases = (builder) => {
  builder
    .addCase(edit_profile_thunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(edit_profile_thunk.fulfilled, (state, action) => {
      if (action.payload?.data?.user) {
        state.user = action.payload.data.user;
      }
      state.loading = false;
    })
    .addCase(edit_profile_thunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || "Profile Update Failed";
    });
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setIsLogin: (state, action) => {
      state.isLogin = action.payload;
    },
    setUserShortcut: (state, action) => {
      state.user = {
        ...state.user,
        defaultFolderShortcut: action.payload
      };
    }
  },
  extraReducers: (builder) => {
    loginCases(builder);
    registerCases(builder);
    verifyCodeCases(builder);
    getUserCases(builder);
    updateUserCases(builder);
    editProfileCases(builder);
    // logoutCases(builder);
  },
});

export const { clearError, setIsLogin, setUserShortcut } = authSlice.actions;

export default authSlice.reducer;
